(function () {
  /**
   * @deprecated Please use number format directly
   */
  // Disable rule in order to declare the global number-format.js function as an Angular constant
  // For how to use format, see https://github.com/Mottie/javascript-number-formatter
  // eslint-disable-next-line angular/window-service
  angular.module('binky.core.number-format-js').constant('numberFormatJs', {format: window.format});
})();
